import React, { useEffect, useCallback, useState} from 'react';
import {lstorage} from 'utils/lstorage.js';
import {setUploadingFile} from 'actions/index.js';
import {setSelectedGuild, setShowLogin, setSigningUp} from 'actions/index.js';
import accounts from 'accounts/Accounts.js';
import Discogs from 'discogs/Discogs.js';
import {connect} from 'react-redux';
import axios from 'axios';
import ipfs from 'decentralized/Ipfs.js';
import {downloadImage} from 'utils/downloadImage.js';


const discogs = new Discogs();

const SAMPLE_PACK = 'SAMPLE_PACK';
const RECORD = 'RECORD';

const DiscogsFlow = ({
    sample,
    setUploadingFile,
    isLoggedIn,
    setShowLogin,
    guildId}) => { 
    const [results, setResults] = useState([]);
    const [name, setName] = useState('');
    const [selectedId, setSelectedId] = useState(undefined);

    const onClickResult = useCallback((result) => {
        if (result.id === selectedId) {
            setSelectedId(undefined);
            sample.discogsId = undefined;
            sample.year = undefined;
            sample.releaseName = undefined;
            sample.styles = [];
            sample.country = null;
            sample.coverArtHash = undefined;
            sample.artistName = undefined;
            sample.releaseType = undefined;
            return;
        }

        setSelectedId(result.id);
        sample.discogsId = result.id;
        sample.year = result.year;
        sample.releaseName = result.title;
        sample.styles = result.style || [];
        sample.country = result.country;
        downloadImage(result.thumb)
            .then(hash => sample.coverArtHash = hash);
        discogs.getReleaseInfo(result.id)
            .then(r => {
                if (r !== undefined) {
                    sample.artistName = r.artists[0].name;
                    sample.releaseName = r.title;
                    sample.releaseType = 'RECORD';
                }
            });
        lstorage.setItem("lastDiscogs", JSON.stringify(result));
    }, [sample, setSelectedId, selectedId]);

    const search = useCallback(() => {
        discogs.searchRecords(stripExtension(name))
            .then(x => setResults(x));
    }, [name, setResults]);

    useEffect(() => {
        let n = stripExtension(sample.name);
        setName(n);
        discogs.searchRecords(stripExtension(n))
            .then(x => {
                if (lstorage.getItem("lastDiscogs")) {
                    let parsed = JSON.parse(lstorage.getItem("lastDiscogs"));
                    if (!x.some(y => y.id === parsed.id)) {
                        x = [parsed, ... x];
                        onClickResult(parsed);
                    }
                }
                setResults(x);
            });
    }, [sample, setResults, setName, setSelectedId]);

    const onClickSave = useCallback(() => {
        setUploadingFile(true);
        setTimeout(async () => {
            await sample.saveSample(guildId);
            setUploadingFile(false);
        }, 100);
    }, [sample, guildId]);

    const showLogin = () => {
        setShowLogin(true);
    };

    if (!isLoggedIn) {
        return (
            <div className="save-new-sample">
            Please <span className="login-button" onClick={showLogin}>log in</span> to save this new sound.
            </div>
        );
    }
    return (
        <div>
          <div className="input-container">
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              type="text"
              className="discogs-search-input"/>
            <div
              onClick={search}
              className="search-button">
              Search
            </div>
          </div>
          {results.length === 0 ? <div className="no-results">No results found. Try editing the name and searching again.</div> : ''}
          <div className="results">
            {results.map(x => <Result isSelected={x.id === selectedId} onClick={onClickResult} result={x}/>)}
          </div>
          <div onClick={onClickSave} className="save-sample-button">
            Save
          </div>
        </div>
    );
}

const Result = ({result, isSelected, onClick}) => {
    let className = "result";
    if (isSelected) {
        className += " selected";
    }
    return (
        <div
          onClick={() => onClick(result)}
          className={className}>
          <img src={result.thumb} className="discogs-thumb"/>
          <div className="result-title">{result.title}</div>
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
      isLoggedIn: state.sequencer.userToken !== undefined,
      guildId: state.guilds.selectedGuild ? state.guilds.selectedGuild.guildId : 0
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setUploadingFile: (a) => dispatch(setUploadingFile(a)),
      setShowLogin: show=> dispatch(setShowLogin(show))
  };
};


const stripExtension = (name) => {
    let extensionIndex = name.indexOf('.flac');
    if (extensionIndex > -1) {
        name = name.slice(0, extensionIndex);
    }
    extensionIndex = name.indexOf('.wav');
    if (extensionIndex > -1) {
        name = name.slice(0, extensionIndex);
    }
    return name;
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscogsFlow);
